(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paint-selection-bridge"] && !Shopify.designMode) return;
  try {
    var paintCollectionHandles = {
  'abarth': 'abarth-car-paint-colours',
  'alfa romeo': 'alfa-romeo-car-paint-colours',
  'alpine': 'alpine-car-paint-colours',
  'aston martin': 'aston-martin-car-paint-colours',
  'audi': 'audi-car-paint-colours',
  'austin-healey': 'austin-healey-classic-car-paint-colours',
  'austin': 'austin-classic-car-paint-colours',
  'bentley': 'bentley-car-paint-colours',
  'bmw': 'bmw-car-paint-colours',
  'byd': 'byd-car-paint-colours',
  'chevrolet': 'chevrolet-car-paint-colours',
  'chrysler': 'chrysler-car-paint-colours',
  'citroen': 'citroen-car-paint-colours',
  'cupra': 'cupra-car-paint-colours',
  'dacia': 'dacia-car-paint-colours',
  'dodge': 'dodge-car-paint-colours',
  'ds automobiles': 'ds-automobiles-car-paint-colours',
  'ferrari': 'ferrari-car-paint-colours',
  'fiat': 'fiat-car-paint-colours',
  'ford': 'ford-car-paint-colours',
  'genesis': 'genesis-car-paint-colours',
  'gwm ora': 'gwm-ora-paint-colours',
  'honda': 'honda-car-paint-colours',
  'hyundai': 'hyundai-car-paint-colours',
  'ineos': 'ineos-grenadier-paint-colours',
  'isuzu': 'isuzu-paint-colours',
  'jaecoo': 'jaecoo-car-paint-colours',
  'jaguar': 'jaguar-car-paint-colours',
  'jeep': 'jeep-car-paint-colours',
  'kia': 'kia-car-paint-colours',
  'lamborghini': 'lamborghini-car-paint-colours',
  'land rover': 'land-rover-range-rover-paint-colours',
  'range rover': 'land-rover-range-rover-paint-colours',
  'leapmotor': 'leapmotor-car-paint-colours',
  'lexus': 'lexus-car-paint-colours',
  'lotus': 'lotus-car-paint-colours',
  'maserati': 'maserati-car-paint-colours',
  'mazda': 'mazda-car-paint-colours',
  'mclaren': 'mclaren-car-paint-colours',
  'mercedes-benz': 'mercedes-benz-car-paint-colours',
  'mercedes': 'mercedes-benz-car-paint-colours',
  'mg': 'mg-car-paint-colours',
  'mini': 'mini-car-paint-colours',
  'mitsubishi': 'mitsubishi-car-paint-colours',
  'morris': 'morris-classic-car-paint-colours',
  'nissan': 'nissan-car-paint-colours',
  'omoda': 'omoda-car-paint-colours',
  'peugeot': 'peugeot-car-paint-colours',
  'polestar': 'polestar-car-paint-colours',
  'porsche': 'porsche-car-paint-colours',
  'renault': 'renault-car-paint-colours',
  'rolls-royce': 'rolls-royce-car-paint-colours',
  'rover': 'rover-car-paint-colours',
  'saab': 'saab-car-paint-colours',
  'seat': 'seat-car-paint-colours',
  'skoda': 'skoda-car-paint-colours',
  'smart': 'smart-car-paint-colours',
  'subaru': 'subaru-car-paint-colours',
  'suzuki': 'suzuki-car-paint-colours',
  'tesla': 'tesla-paint-colours',
  'toyota': 'toyota-car-paint-colours',
  'triumph': 'triumph-classic-car-paint-colours',
  'tvr': 'tvr-car-paint-colours',
  'vauxhall': 'vauxhall-car-paint-colours',
  'volkswagen': 'volkswagen-car-paint-colours',
  'volvo': 'volvo-car-paint-colours'
};

function normalisePaintMake(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function getPaintMake(widget) {
  var selectedMake = widget.querySelector('select[name="manufacturer"]');
  if (selectedMake && selectedMake.value) return normalisePaintMake(selectedMake.value);

  var vehicleInfo = widget.querySelector('.paint-lookup-results > p');
  var vehicleText = normalisePaintMake(vehicleInfo ? vehicleInfo.textContent : '');
  var makes = Object.keys(paintCollectionHandles).sort(function (a, b) {
    return b.length - a.length;
  });
  return makes.find(function (make) {
    return vehicleText === make || vehicleText.indexOf(make + ' ') === 0;
  }) || '';
}

function getPaintFinish(card, name) {
  var finishNode = card.querySelector('.paint-swatch-finish');
  var finish = normalisePaintMake(finishNode ? finishNode.textContent : '');
  if (finish === 'unknown' || finish === 'normal' || finish === 'solid') finish = '';
  if (!finish && /metallic|\bmet\.?\b/i.test(name)) finish = 'metallic';
  if (!finish && /pearl|\bprl\.?\b/i.test(name)) finish = 'pearl';
  if (!finish && /xirallic/i.test(name)) finish = 'xirallic';
  if (finishNode) {
    if (!finish) {
      finishNode.hidden = true;
      finishNode.textContent = '';
    } else {
      finishNode.hidden = false;
      finishNode.textContent = finish === 'pearl' ? 'Pearlescent' : finish.replace('_', ' ');
    }
  }
  return finish;
}

function enhancePaintCards(bridge, widget) {
  widget.classList.add('paint-selection-enabled');
  widget.querySelectorAll('.paint-swatch-card').forEach(function (card) {
    if (card.dataset.paintSelectionReady === 'true') return;

    var nameNode = card.querySelector('strong');
    var codeNode = card.querySelector('.paint-swatch-code');
    var swatch = card.querySelector('.paint-swatch');
    var name = nameNode ? nameNode.textContent.trim() : '';
    var code = codeNode ? codeNode.textContent.trim() : '';
    var finish = getPaintFinish(card, name);

    if (swatch) {
      swatch.classList.remove('paint-swatch--metallic', 'paint-swatch--pearl', 'paint-swatch--xirallic');
      if (finish === 'metallic') swatch.classList.add('paint-swatch--metallic');
      if (finish === 'pearl') swatch.classList.add('paint-swatch--pearl');
      if (finish === 'xirallic') swatch.classList.add('paint-swatch--xirallic');
    }

    card.dataset.paintSelectionReady = 'true';
    card.classList.add('is-selectable');
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', 'Select ' + [name, code].filter(Boolean).join(' '));

    function choosePaint() {
      var make = getPaintMake(widget);
      var collectionHandle = paintCollectionHandles[make] || '';
      var destination = collectionHandle
        ? '/collections/' + collectionHandle
        : bridge.dataset.defaultCollectionUrl;
      var colour = swatch && !swatch.classList.contains('paint-swatch-no-hex')
        ? swatch.style.backgroundColor
        : '';
      var selection = {
        name: name,
        code: code,
        finish: finish,
        colour: colour,
        manufacturer: make,
        collection: destination,
        selectedAt: Date.now()
      };

      try {
        window.localStorage.setItem('breakwellsSelectedPaint', JSON.stringify(selection));
      } catch (error) {
        selection.selectedAt = Date.now();
      }

      var target = new URL(destination, window.location.origin);
      target.searchParams.set('selected_paint', '1');
      if (name) target.searchParams.set('colour_name', name);
      if (code) target.searchParams.set('paint_code', code);
      if (finish) target.searchParams.set('paint_finish', finish);
      if (colour) target.searchParams.set('paint_swatch', colour);
      window.location.assign(target.toString());
    }

    card.addEventListener('click', choosePaint);
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choosePaint();
      }
    });
  });
}

document.querySelectorAll('[data-paint-selection-bridge]').forEach(function (bridge) {
  if (bridge.dataset.initialized === 'true') return;
  bridge.dataset.initialized = 'true';
  var container = bridge.parentElement;
  var widget = container ? container.querySelector('#vehicle-paint-colour-lookup') : null;
  if (!widget) return;

  enhancePaintCards(bridge, widget);
  var observer = new MutationObserver(function () {
    enhancePaintCards(bridge, widget);
  });
  observer.observe(widget, { childList: true, subtree: true });
});
  } catch(e) { console.error(e); }
})();

})();
